const locale = {
  NUMBER_4: 4,
  TITLE_PAGE_404: 'Algo salió',
  BOLD_TITLE_PAGE_404: 'mal',
  SUBTITLE_PAGE_404: 'Parece que no podemos encontrar la página que estás buscando.',
  HOME_BUTTON_PAGE_404: 'Volver al inicio',
};

export default locale;
